import React, {Component} from "react";
import FJCustomScroll from "fj-components/FJCustomScroll";
import FJPageHeader from "fj-components/FJPageHeader";
import FJFixedLayout from 'fj-components/FJFixedLayout';
import styles from "./FJResourcesTransitionList.module.less";
import FJLocalStore from "../../../store/FJLocalStore";
import FJResourcesPhotoAnimationCommon from "./FJResourcesPhotoAnimationCommon";

class FJResourcesPhotoTransitionList extends Component{

	_getCollectionList = () => {
		let {allResources, classes} = this.props;
		let items = [];
		for (let i in allResources) {
			if (allResources.hasOwnProperty(i)) {
				let item = allResources[i];
				items.push(
					<FJPageHeader key={item.category}
												title={FJLocalStore._(item.category)}
												id={i}
												classes={classes.pageHeaderClasses}
												hasSeeAll={false}
					>
						{this._renderList(item.items, this.props.isShow)}
					</FJPageHeader>
				);
			}
		}

		return items;
	}

	_renderList = (list, active) => {
		let {
			onAddClick,
			onHandleClick,
			resourceViewInfo,
			classes,
			onMediaDrag,
			config,
			allTooltip,
			toggleTooltip,
			oneTooltip,
			animationSelectedId
		} = this.props;


		let {
			width,
			height,
			space,
			marginBottom
		} = resourceViewInfo;

		let {
			activeColor,
			addIconToolTip
		} = config;
		return <FJFixedLayout
			basicWidth={width}
			space={space}
			active={active}
			render={(itemWidth, space, column) => {
				let itemHeight = height;
				let items = [];
				list.forEach((item, index) => {
					items.push(
						<FJResourcesPhotoAnimationCommon
							key={item.label}
							id={item.type}
							width={itemWidth}
							height={itemHeight}
							marginRight={(index + 1) % column === 0 ? 0 : space}
							marginBottom={marginBottom}
							name={FJLocalStore._(item.label)}
							hasName={true}
							type={item.type}
							hasAddBtn
							onAddClick={onAddClick}
							selectMedia={onHandleClick}
							classes={classes.itemClasses}
							activeColor={activeColor}
							onMediaDrag={onMediaDrag}
							addIconToolTip={addIconToolTip}
							allTooltip={allTooltip}
							toggleTooltip={toggleTooltip}
							oneTooltip={oneTooltip}
							transitionName={item.type}
							isChoose={animationSelectedId === item.type}
						/>
					)
				});
				return items;
			}}
		/>
	}

	render() {

		let {
			isShow,
			classes
		} = this.props;

		return (
			<div className={styles.list_box} style={{display: isShow ? 'block' : 'none'}}>
				<FJCustomScroll classes={classes.textMoreClasses}>
					{this._getCollectionList()}
				</FJCustomScroll>
			</div>
		)
	}

}



export default FJResourcesPhotoTransitionList;